module.exports = __webpack_public_path__ + "img/approve-cancel-reservation.01f469d7.svg";